<div class="interactive-message-bubble">
  <div class="interactive-message-bubble_reply-message-container">
    <label class="interactive-message-bubble_reply-header">{{content.title}}</label>
    @if (content.replyMessage) {
      <label class="interactive-message-bubble_reply-message">{{content.replyMessage}}</label>
    }
  </div>
  <label class="interactive-message-bubble_message">{{content.messageDisplay}}</label>
  <app-read-receipt [messageStatus]="content['messageStatus']"></app-read-receipt>
</div>